import * as React from 'react';

interface EntryTitleProps {
  text: string | null;
  onChange: (value: string) => void;
}

export const EntryTitle: React.SFC<EntryTitleProps> = (props) => {
  const changeHandler = (e: React.FormEvent<HTMLInputElement>) => {
    props.onChange(e.currentTarget.value);
  };

  let text = props.text;
  if (!text) {
    text = '';
  }

  return (
    <input
      type="text"
      className="entry-title"
      onChange={changeHandler}
      value={text}
      placeholder={'No Title'}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/entryTitle.tsx